import React from "react";
import tabguidelines1 from "assets/images/png/tabguidelines1.png";
import tabguidelines2 from "assets/images/png/tabguidelines2.png";

const ComponentPrimaryDatas = [
	{
		id: 1,
		title: "Do",
		titleClassname: "active",
		image: tabguidelines1,
		description: "Text labels appear in a single row and should clearly and succinctly describe the content of the tab they represent. Tab content should contain a cohesive set of items that share a common characteristic. ",
	},
	{
		id: 2,
		title: "Don’t",
		titleClassname: "inactive",
		image: tabguidelines2,
		description: "Avoid placing tabs within another tab, as it complicates navigation. Nested tabs increase cognitive load and disrupt user flow. Keeping tabs flat ensures a simpler, more intuitive experience. ",
	},
];

const GuidelineCardTab = () => {
	return (
		<div className="guideline-card d-flex justify-content-between">
			{ComponentPrimaryDatas.map((data) => (
				<div key={data.id} className="guideline-wrapper">
					<h6 className={`guideline-badge plt-body-compact-md dis-mb-8 ${data.titleClassname}`}>{data.title}</h6>
					<div className="guideline-detail-wrapper d-flex align-items-center justify-content-center">
						<div className="guideline-img">
							<img src={data.image} alt="userimage" />
						</div>
					</div>
					<p className="guideline-desc plt-body-md dis-mt-12">{data.description}</p>
				</div>
			))}
		</div>
	);
};

export default GuidelineCardTab;
